import { useState } from 'react';
import { GuestLogin, ResetPassword, SetToken } from 'services/Session';
import { IsValidEmail } from "utils/Validation";

export function forgotPasswordForm(props) {
	const [username, setUsername] = useState('')
	const [loading, setLoading] = useState(false)
	const [msg, setMsg] = useState('')
	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const guest = await GuestLogin()
			await SetToken(guest.data.token)
			const res = await ResetPassword({[IsValidEmail(username) ? 'email' : 'phone']: username})
			setMsg(res?.data?.message?? 'Tautan pengaturan kata sandi sudah dikirim ke '+username+'.')
		} catch (e) {
			setMsg(e?.response?.data?.error?.message?? 'Email atau nomor hp tidak ditemukan. Silakan periksa kembali email atau nomor hp Anda.')
			setTimeout(() => {
				setMsg('')
			}, 3000)
		}
		setLoading(false)
	}
	return (
	<section>
		<div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
			{msg && (
				<div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center">
					<span>{msg}</span>
					<button className="ml-4 text-white focus:outline-none" onClick={() => setMsg('')}>✖</button>
				</div>
			)}
			<div onClick={() => props.history.push('/')} className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white cursor-pointer">
				<img className='transition ease-in-out hover:-translate-y-1 hover:scale-150 duration-300 h-[40px] my-[10px]' src={window.location.origin+"/assets/images/logo-pernik-hsi.png"} alt="logo"/>
			</div>
			<div className="w-full text-sm bg-white rounded-md shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
				<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
					<h3 className="font-bold leading-tight tracking-tight text-gray-900 text-center mb-5">
						Atur Ulang Kata Sandi
					</h3>
					<form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
						<div>
							<label htmlFor="username" className="block mb-2 font-medium text-gray-900 dark:text-white">Email atau Nomor HP</label>
							<input onChange={(e) => setUsername(e.target.value)} name="username" id="username" placeholder="email@example.com" className="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500" required autoFocus/>
						</div>
						<div className="flex justify-end">
							<button onClick={() => props.history.push('/login')} type="button" className="px-4 py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400">Kembali</button>
							<button type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-4 py-2 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
								{loading ? (
									<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
										<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
									</svg>
								) : (
									"Reset"
								)}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
	)
}